var map = {
	"./en-ca.json": 895,
	"./en-us.json": 896
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 894;


//////////////////
// WEBPACK FOOTER
// ./src/intl/resources ^\.\/.*\.json$
// module id = 894
// module chunks = 0